
import React from "react";

export default function CustomInput({
  leftImg,
  rightImg,
  placeHolder = "",
  fontSize = 20,
  value = "",
  onChange = () => {},
  onEnter = () => {},
  type="text"
}) {
  return (
    <div className="flex flex-row items-center gap-4 bg-white border-[3px] p-1 border-[#B87F53] rounded-3xl">
      {leftImg ? (
        <div
          onClick={() => {}}
          className="active:opacity-50 hover:opacity-80 cursor-pointer ml-2 "
        >
          <img
            src={leftImg}
            className="object-contain "
            style={{ width: fontSize, height: fontSize }}
          />
        </div>
      ) : null}
      <input
        value={value}
        onChange={(e) => {
          if (onChange != null) {
            onChange(e.target.value);
          }
        }}
        type={type}
        className="font_Kanit font-medium text-center text-[#B87F53] rounded-3xl w-full"
        style={{ fontSize: fontSize }}
        placeholder={placeHolder}
        onKeyDown={(event) => {
          if (event.key.toLocaleLowerCase() == "enter") {
            if (onEnter != null) {
              onEnter();
            }
          }
        }}
      />
      {rightImg ? (
        <div
          onClick={() => {}}
          className="active:opacity-50 hover:opacity-80 cursor-pointer mr-2 "
        >
          <img
            src={rightImg}
            className="object-contain "
            style={{ width: fontSize, height: fontSize }}
          />
        </div>
      ) : null}
    </div>
  );
}
